export default "__VITE_ASSET__DX2sQbzR__"